import { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import BudgetPercentageFields from "./BudgetPercentageFields";
import BudgetServiceSelects from "./BudgetServiceSelects";
import RemoveButton from "./RemoveButton";
import BudgetServiceFieldsMobile from "./mobile/BudgetServiceFieldsMobile";
import { ISelectedServices, IVehicleData } from '../types';
import { ITruckerPayPlanData } from '../../../../models/truckerPayPlan';
import ConfirmDialog from '../../../dialogs/ConfirmDialog';

interface IBudgetServiceFieldsProps {
  serviceId: string;
  serviceName?: string;
  usedServices: ISelectedServices[];
  failureModeId?: string;
  isExternalService?: boolean;
  volkstotalPercentage?: number;
  dealershipPercentage?: number;
  warrantyPercentage?: number;
  showPercentageFields?: boolean;
  vehicleData?: IVehicleData;
  serviceType: string;
  truckerPayPlan?: ITruckerPayPlanData;
  calculatedSubtotal: string;
  calculatedTruckerPayPlanSubtotal: string;
  onServiceChange?: (serviceId: string, serviceData?: any) => void;
  onFailureModeChange?: (failureModeId: string) => void;
  onChangeServiceType?: (serviceType: string) => void;
  onPackageItemsLoadingChange?: (loading: boolean) => void;
  onVolkstotalPercentageChange?: (value: number) => void;
  onDealershipPercentageChange?: (value: number) => void;
  onWarrantyPercentageChange?: (value: number) => void;
  onRemoveService?: () => void;
}

const BudgetServiceFields = ({
  serviceId,
  serviceName,
  failureModeId,
  isExternalService,
  volkstotalPercentage,
  dealershipPercentage,
  warrantyPercentage,
  showPercentageFields,
  vehicleData,
  serviceType,
  truckerPayPlan,
  usedServices,
  calculatedSubtotal,
  calculatedTruckerPayPlanSubtotal,
  onServiceChange,
  onFailureModeChange,
  onVolkstotalPercentageChange,
  onDealershipPercentageChange,
  onWarrantyPercentageChange,
  onRemoveService,
  onChangeServiceType,
  onPackageItemsLoadingChange,
}: IBudgetServiceFieldsProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  
  if (isMobile) {
    return (
      <BudgetServiceFieldsMobile
        serviceId={serviceId}
        serviceName={serviceName}
        usedServices={usedServices}
        failureModeId={failureModeId}
        isExternalService={isExternalService}
        volkstotalPercentage={volkstotalPercentage}
        dealershipPercentage={dealershipPercentage}
        warrantyPercentage={warrantyPercentage}
        showPercentageFields={showPercentageFields}
        vehicleData={vehicleData}
        serviceType={serviceType}
        truckerPayPlan={truckerPayPlan}
        onServiceChange={onServiceChange}
        onFailureModeChange={onFailureModeChange}
        onChangeServiceType={onChangeServiceType}
        onPackageItemsLoadingChange={onPackageItemsLoadingChange}
        onVolkstotalPercentageChange={onVolkstotalPercentageChange}
        onDealershipPercentageChange={onDealershipPercentageChange}
        onWarrantyPercentageChange={onWarrantyPercentageChange}
        onRemoveService={onRemoveService}
      />
    );
  }
  
  return (
    <div className="flex flex-col lg:flex-row gap-4 w-full items-center">
      <div className="flex flex-col lg:flex-row gap-10 items-start flex-1 min-w-0 flex-wrap">
        {!isExternalService && (
          <div className="flex w-full lg:w-auto flex-shrink-0 mb-4">
            <BudgetServiceSelects
              serviceId={serviceId}
              serviceName={serviceName}
              usedServices={usedServices}
              vehicleData={vehicleData}
              serviceType={serviceType}
              truckerPayPlan={truckerPayPlan}
              onChangeItem={(itemId, serviceData) => onServiceChange?.(itemId, serviceData)}
              onChangeModoFalha={(modoFalhaId) => onFailureModeChange?.(modoFalhaId)}
              onChangeServiceType={(newServiceType) => onChangeServiceType?.(newServiceType)}
              onPackageItemsLoadingChange={onPackageItemsLoadingChange}
            />
          </div>
        )}
        <BudgetPercentageFields
          volkstotalPercentage={volkstotalPercentage}
          dealershipPercentage={dealershipPercentage}
          warrantyPercentage={warrantyPercentage}
          showPercentageFields={showPercentageFields}
          calculatedSubtotal={calculatedSubtotal}
          isExternalService={isExternalService}
          calculatedTruckerPayPlanSubtotal={calculatedTruckerPayPlanSubtotal}
          onVolkstotalPercentageChange={onVolkstotalPercentageChange}
          onDealershipPercentageChange={onDealershipPercentageChange}
          onWarrantyPercentageChange={onWarrantyPercentageChange}
        />
      </div>
      {onRemoveService && (
        <div className="flex items-center flex-shrink-0  ml-auto lg:ml-0">
          <RemoveButton label="Remover serviço" onClick={() => setShowConfirmDialog(true)} />
        </div>
      )}
      
      <ConfirmDialog
        show={showConfirmDialog}
        title="Remover serviço"
        body="Deseja realmente remover este serviço? Esta ação não pode ser desfeita."
        onClose={() => setShowConfirmDialog(false)}
        onConfirm={() => {
          onRemoveService?.();
          setShowConfirmDialog(false);
        }}
      />
    </div>
  );
};

export default BudgetServiceFields;
